import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useHistory } from 'react-router-dom';

const RouteTitle = ({ title, returnable = false }) => {
    const history = useHistory();

    const handleBackClick = () => {
        const currentPath = history.location.pathname;
        const pathParts = currentPath.split('/');
        
        if (pathParts[1] === 'module' && pathParts[3] === 'cheatsheet' || pathParts[3] === 'article') {
          const newPath = pathParts.slice(0, -2).join('/');
          history.push(newPath);
        } else {
          const newPath = pathParts.slice(0, -1).join('/');
          history.push(newPath);
        }
      };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', paddingBottom: 3 }}>
            {returnable && (
                <div onClick={handleBackClick} style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}>
                    <PlayCircleOutlineIcon 
                        sx={{ 
                            marginRight: 2, 
                            color: '#006666', 
                            transform: 'rotate(180deg)', 
                            fontSize: '3rem',
                            '&:hover': {
                                color: '#02a8a8'
                            }
                        }} 
                    />
                </div>
            )}
            <Typography variant="h1" sx={{ fontSize: 28, fontWeight: 'bold', color: '#333333' }}>
                {title}
            </Typography>
        </Box>
    );
};

export default RouteTitle;